import React from 'react'
import man_camera_long from '../../../assets/man_camera_long.png'
import wheel from '../../../assets/FeemFundy-Icon-B1.png'
import FeemFundy_Icon from '../../../assets/FeemFundy-Icon.png'

const HomeWidePool = () => {
	const lists = [
		{
			id: 1,
			title: 'Producers',
			info: 'There are many A-list producers on the platform for project collaboration',
		},
		{
			id: 2,
			title: 'Cinematographers',
			info: 'There are many A-list cinematographers on the platform for project collaboration',
		},
		{
			id: 3,
			title: 'Movie Directors	',
			info: 'There are many A-list directors on the platform for project collaboration',
		},
		{
			id: 4,
			title: 'Photographers',
			info: 'There are many A-list photographers on the platform for project collaboration',
		},
	]

	return (
		<section className='homepage_wide_pool'>
			<div className='container' style={{ position: 'relative' }}>
				<img
					src={wheel}
					alt='Film wheel icon'
					className='wheel'
					style={{ position: 'absolute' }}
				/>

				<div className='padbox'>
					<div className='row no-gutters'>
						<div
							className='col-md-5 homepage_wide_pool_img '
							style={{
								background: `url(${man_camera_long})`,
							}}
						>
							<div className='d-flex text'>
								<div className='text2'>
									<h1>Wide</h1>
									<h1>pool of</h1>
									<h1>professionals</h1>
								</div>
							</div>
						</div>
						<div className='col-md-7' style={{ position: 'relative' }}>
							<img
								src={FeemFundy_Icon}
								alt='feemfundy small icon'
								className='small_wheel'
							/>
							<div className='row no-gutters'>
								{lists.map((list) => (
									<div key={list.id} className='col-md-6 col-sm-6 mb-0 pb-0'>
										<div className='homepage_wide_pool_whitebox'>
											<h5> {list.title} </h5>
											<p className='mb-0 pb-0'> {list.info} </p>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default HomeWidePool
